<div class="p-6 px-md-12 py-md-4 rounded border bg-white pulse mx-md-10 mb-9">
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center">
    <p class="text-primblack mb-0 text-center text-md-start mb-4 mb-md-0">
      The expert's help is only for subscribed customers. Please activate a subscription for an access.
    </p>
    <button
      type="button"
      (click)="continueClick()"
      class="btn btn-outline border-2 app-btn-yellow px-md-15"
    >
      Continue
    </button>
  </div>
</div>
